// extracted by mini-css-extract-plugin
module.exports = {"container":"TermOfUse_container__1Oib9","title":"TermOfUse_title__Z_wtX","content":"TermOfUse_content__1KS_r","p_level2":"TermOfUse_p_level2__2L_U6"};